const menu = [
    {
        name: "adminDashboard",
        icon: "icon-[ic--twotone-space-dashboard]",
        title: "Dashboard",
        access: "admin",
        type: "btn",
    },
    {
        name: "adminWorkshop",
        icon: "icon-[ph--chalkboard-teacher-duotone]",
        title: "Daftar Kegiatan",
        access: "sysdev",
        type: "btn",
    },
    {
        name: "participant",
        icon: "icon-[ph--chalkboard-teacher-duotone]",
        title: "Verifikasi Pembayaran",
        access: "sysdev",
        type: "btn",
    },
    {
        name: "adminHypierslink",
        icon: "icon-[ph--chalkboard-teacher-duotone]",
        title: "Hyperlink Diklat",
        access: "sysdev",
        type: "btn",
    },
    {
        name: "adminListCertificate",
        icon: "icon-[ph--chalkboard-teacher-duotone]",
        title: "Daftar Sertifikat",
        access: ["admin", "sysdev"],
        type: "btn",
    },
    {
        name: "adminSuratMenyurat",
        icon: "icon-[ph--envelope-duotone]",
        title: "Daftar Surat",
        access: ["admin", "sysdev"],
        type: "btn",
    },
];

export default menu;
